module.exports = __webpack_public_path__ + "img/cv-template-5.29474055.png";